import { ITaskActivity } from '../../../../models/taskActivity.model';
import { AppAction } from '../../../../state/app';
import { FAILURE, REQUEST, SUCCESS } from '../../../../utils/actionTypeUtil';
import {
  CLEAR_COMMENT_DASHBOARD,
  FETCH_COMMENT_DASHBOARD_LIST,
} from './commentDashboard.actions';

export interface CommentDashboardState {
  loading: boolean;
  items: ReadonlyArray<ITaskActivity>;
  errorMessage: string;
  totalItems: number;
}

const initialState: CommentDashboardState = {
  errorMessage: '',
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: CommentDashboardState = initialState,
  action: AppAction,
): CommentDashboardState => {
  switch (action.type) {
    case REQUEST(FETCH_COMMENT_DASHBOARD_LIST):
      return { ...state, loading: true };
    case SUCCESS(FETCH_COMMENT_DASHBOARD_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_COMMENT_DASHBOARD_LIST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case CLEAR_COMMENT_DASHBOARD:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
